import useDidMount from '../../../hooks/useDidMount';
import { BaseRootStore } from '../../rootStore/baseRootStore';

export default function usePriceConfig(rootStore: BaseRootStore) {
  const { priceConfigStore } = rootStore;

  useDidMount(() => {
    void priceConfigStore.fetchConfig();
  });

  return {
    config: priceConfigStore.config,
    isLoading: priceConfigStore.loading,
    isLoaded: priceConfigStore.loaded,
    error: priceConfigStore.error,
  };
}
